import { useCookies } from 'react-cookie';

export default <T extends string>(keys: T | T[]) =>
  useCookies<T, { [key in T]: string }>(Array.isArray(keys) ? keys : [keys]);
